import React from 'react'

import Button from '../form/Button'
import BottomDrawer from './BottomDrawer'
import { useI18N } from '../../../libraries/i18n/hook'
import FiltersIcon from '../../../assets/icons/filters.svg?react'

type Props = {
  children: React.ReactNode | React.ReactNode[],
  showFilters: boolean,
  toggleShowFilters: (show: boolean) => void,
}
const FiltersBox: React.FC<Props> = ({ children, showFilters, toggleShowFilters }) => {
  const { t } = useI18N()
  return (
    <>
      <div className='block md:hidden text-end -me-5'>
        <Button variant='flat' onClick={() => toggleShowFilters(true)} icon={<FiltersIcon />}>{t('common.filter')}</Button>
      </div>
      {showFilters && (
        <BottomDrawer onClose={() => toggleShowFilters(false)}>{children}</BottomDrawer>
      )}
      <div className='hidden md:block'>{children}</div>
    </>
  )
}

export default FiltersBox
